import axios from 'axios'
import {getServerApi} from '../config/deployment'

let envUri = getServerApi()
let paymentNotifyUri = envUri+'/api/mk/notify'
let bookingApplicatioTransactionUri = envUri+'/api/transactions/bookings/application'

export const startBookingApplicationTransaction=({dealId, accountId})=>{
  return new Promise((resolve, reject) => {
    var data = {
      dealId: dealId,
      accountId:accountId
    }
    axios.post(bookingApplicatioTransactionUri, data)
      .then(res => {
        resolve(res.data.body.result)
      })
      .catch(err => {
        reject(err)
      })  
  })
}

export const makePaymentResultCallback = async ({paymentReturnMessage, mac}) => {
  try {
      const body = {
          "json":paymentReturnMessage,
          "mac": mac
      };
      const config = {
          // headers: {
          //   'Content-Type': 'application/x-www-form-urlencoded'
          // }
      };
      const response = await axios.post(paymentNotifyUri, body, config);

      return response.data.body === 'OK';
  }
  catch (error) {
    console.log("paymentService | makePaymentResultCallback | err: ", error);
  }
};



// WEBPACK FOOTER //
// ./src/payments/paymentService.js